import * as yup from "yup";

export const addResourceSchema = yup.object().shape({
  resourceName: yup.string().required("Name is required"),
  resourceType: yup.string().required("Resource type is required"),
});

export const resourceTypes = {
  ASSIGNMENT: "ASSIGNMENT",
  RECORDING: "RECORDING",
  STUDY_MATERIAL: "STUDY MATERIAL",
  LINKS: "LINKS",
};